module.exports = __webpack_public_path__ + "img/pin-cluster.300fdd5b.svg";